import React from 'react';
import Styled from './Styled';
const LinkButtonWithIcon = ({ icon, title, ...props }) => {
    return (React.createElement(Styled.Wrapper, Object.assign({}, props, { type: "link" }),
        icon,
        title));
};
export default LinkButtonWithIcon;
